import { render } from "./PostCardAuth.vue?vue&type=template&id=850e5f84"
import script from "./PostCardAuth.vue?vue&type=script&lang=js"
export * from "./PostCardAuth.vue?vue&type=script&lang=js"

import "./PostCardAuth.vue?vue&type=style&index=0&id=850e5f84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__